export default "__VITE_ASSET__BbIb0idF__"